import React from 'react';
import { LayoutGrid, List, Columns } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * ViewSwitcher Component
 * 
 * Standardized view mode switcher (Grid/List/Table) with pill styling.
 * Part of the Base44 Design System.
 * 
 * @param {string} viewMode - Current view mode: 'grid', 'list', or 'table'
 * @param {function} onViewChange - View change handler
 * @param {string} className - Additional classes
 */
export const ViewSwitcher = ({ 
  viewMode = 'grid', 
  onViewChange, 
  className 
}) => {
  const views = [
    { id: 'grid', icon: LayoutGrid, label: 'Grid', shortLabel: 'Grid' },
    { id: 'list', icon: List, label: 'List View', shortLabel: 'List' },
    { id: 'table', icon: Columns, label: 'Kanban View', shortLabel: 'Kanban' },
  ];

  return (
    <div className={cn("flex gap-1 bg-slate-100 dark:bg-slate-800 rounded-full p-1", className)}>
      {views.map((view) => {
        const Icon = view.icon;
        const isActive = viewMode === view.id;
        
        return (
          <button
            key={view.id}
            onClick={() => onViewChange(view.id)}
            className={cn(
              "h-9 px-4 rounded-full transition-all flex items-center gap-2",
              isActive
                ? "bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 shadow-sm"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200"
            )}
            title={view.label}
            aria-label={view.label}
          >
            <Icon className="h-4 w-4 flex-shrink-0" />
            <span className="hidden md:inline text-sm font-medium">{view.shortLabel}</span>
          </button>
        );
      })}
    </div>
  );
};
